export const AVAILABLE_MATERIALS = [
    '10x5_Block',
    '11x3x2_Angled_Block',
    '11x5_H_block',
    '14x7_Block',
    '15x5_Block',
    '16_Tooth_Gear',
    '24_Tooth_Gear',
    '2x4_L_Shaped_Beam',
    '3x11_Technic_Plate',
    '3x3_T_Beam',
    '3x3_Triangle_With_3_Axle_Hole',
    '40_Tooth_Gear',
    '4x4_Angled_Beam',
    '5x11_Technic_Plate',
    '5x3_L_beam',
    '5x3_T_Beam_With_2_Axle_Holes',
    '6x4_Angled_Beam',
    '7x2_C_beam',
    '7x3_Angled_Beam',
    '7x3x3_Angled_Beam_With_Axle_Hole',
    '7x5_Block',
    '7x7_Block',
    '8_Tooth_Gear',
    '90_Degree_Peg',
    'Angle_Connector',
    'Angle_Connector_135_Degree',
    'Axel_3',
    'Axel_8_With_Stop',
    'Axel_Joiner',
    'Axle_10',
    'Axle_12',
    'Axle_16',
    'Axle_2',
    'Axle_3_With_Stop',
    'Axle_4',
    'Axle_4_with_Stop',
    'Axle_5.5_With_Stud',
    'Axle_5',
    'Axle_7',
    'Axle_8',
    'Axle_9',
    'Axle_Connector',
    'Axle_Connector_With_Hole',
    'Axle_Peg',
    'Beam_11',
    'Beam_13',
    'Beam_15',
    'Beam_1_with_Axle_1',
    'Beam_1_with_Perpendicular_Axles_2',
    'Beam_2',
    'Beam_3',
    'Beam_5',
    'Beam_7',
    'Beam_9',
    'Beam_Block_Joiner',
    'Beam_Size_2_With_1_Axle_Hole',
    'Belt_Wheel',
    'Bevel_Gear',
    'Big_Wheel',
    'Button',
    'Button_2C',
    'Castor_Socket',
    'DC_Motor',
    'DIP_Switch',
    'Double_Perpendicular_Axle_Joiner',
    'Dynamex_Moter',
    'Flat_Beam_2_With_2_Axle_Holes',
    'Flexible_Axle_14',
    'Full_Bush',
    'H_Shape_Beam_3x5',
    'Half_Bush',
    'Half_Peg',
    'Joystick',
    'LED_2C',
    'Laser',
    'Lift_Arm',
    'Light_Sensor',
    'Long_Peg',
    'Motor_Bridge',
    'N20_Motor',
    'OLED_Display',
    'PEECEE',
    'POM_Ball',
    'Peg',
    'Peg_Joiner',
    'Perpendicular_Axle_Joiner',
    'Perpendicular_Axle_Joiner_2_Holes',
    'Perpendicular_Axle_Joiner_3L_With_Pegs',
    'Perpendicular_Triple_Axle_Joiner',
    'Pin_Connector_Toggle_Joint',
    'Play_Shield',
    'Pole_Reversal_Handle',
    'Potentiometer',
    'Pulley_Belt',
    'RGB_LED',
    'Rack_Of_Size_13',
    'Rack_Of_Size_7',
    'Rain_Sensor',
    'Range_Sensor',
    'Rubber_Band',
    'Servo_Motor_MG90S',
    'Slide_Switch',
    'Soundcard_and_SD_CARD',
    'String',
    'String_Reel_3x2x3_Drum_With_Axle_Hole',
    'Technic_Hole_With_Pin',
    'Wheel_24mm',
    'Wheel_30mm',
    'Wheel_43mm',
    'Wheel_Rim_30mm',
    'White_LED',
    'Worm_Gear',
]